import React from "react";
import { Sparkles, CheckCircle2, AlertTriangle, AlertCircle as AlertCircleIcon } from "lucide-react";
import AIAuditBadge from "@/components/AIAuditBadge";

/**
 * Renderar resultatet av AI-granskning (overall_score, compliance_checks, recommendations).
 */
export default function CaseAIReview({ review }) {
  if (!review) return null;
  return (
    <div className="mt-6 p-5 bg-blue-50 border border-blue-200 rounded-sm" data-testid="ai-review-result">
      <div className="flex items-start justify-between gap-4 mb-3">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-blue-700" />
          <div className="text-xs uppercase tracking-wider font-semibold text-blue-700">AI-granskning</div>
        </div>
        {typeof review.overall_score === "number" && (
          <div className={`text-2xl font-semibold ${
            review.overall_score >= 80 ? "text-emerald-700" :
            review.overall_score >= 60 ? "text-amber-700" : "text-red-700"
          }`} style={{ fontFamily: "Outfit" }}>
            {review.overall_score}<span className="text-base text-zinc-400">/100</span>
          </div>
        )}
      </div>
      {review.summary && <p className="text-sm text-zinc-800 mb-3">{review.summary}</p>}
      {review.compliance_checks?.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3">
          {review.compliance_checks.map((cc, i) => {
            const Icon = cc.status === "ok" ? CheckCircle2 : cc.status === "warning" ? AlertTriangle : AlertCircleIcon;
            const color = cc.status === "ok" ? "text-emerald-700" : cc.status === "warning" ? "text-amber-700" : "text-red-700";
            return (
              <div key={i} className="flex gap-2 p-2 bg-white border border-zinc-200 rounded-sm">
                <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${color}`} />
                <div className="min-w-0">
                  <div className={`text-xs font-semibold uppercase tracking-wider ${color}`}>{cc.area}</div>
                  <div className="text-xs text-zinc-700">{cc.comment}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {review.recommendations?.length > 0 && (
        <div className="mt-3 text-sm">
          <div className="font-semibold text-zinc-900 mb-1">Rekommendationer</div>
          <ul className="text-xs text-zinc-700 space-y-1">
            {review.recommendations.map((r, i) => <li key={i}>• {r}</li>)}
          </ul>
        </div>
      )}
      {review.audit_id && (
        <div className="mt-4 pt-3 border-t border-blue-200 flex justify-end">
          <AIAuditBadge auditId={review.audit_id} kind="project_review" />
        </div>
      )}
    </div>
  );
}
